import React, { useRef, createRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import TopicElement from '../TopicElement/TopicElement';

import './TopicScroller.scss';

const MOBILE_PADDING = 50;

const TopicScroller = React.forwardRef(
  (
    {
      isTopicSelected,
      isVisible,
      sectionHeight,
      sectionWidth,
      mainBubbleSize,
      topics,
      refTopicAnchors,
      bubbleLabels,
      redirectHandler,
      onMobile 
    },
    theRef
  ) => {
  useEffect(() => {
    
  }, []);

  useLayoutEffect(() => {

  }, []);

  refTopicAnchors.current = topics.map(topic => createRef(null));

  const mobileHeight = mainBubbleSize + 2 * MOBILE_PADDING;


  return (
    <div 
      className={`innovation-topic-scroller ${ isVisible ? '' : 'invisible' }`}
      ref={theRef}
      style={{
        marginTop: onMobile ? `-${sectionHeight - (sectionHeight - mobileHeight) / 2}px` : `-${sectionHeight}px`,
        marginBottom: onMobile ? `${(sectionHeight - mobileHeight) / 2}px` : ''
      }}
    >
      <div className="innovation-ts-inner">
        {
          topics.map((topic, i) => (
            <div
              key={i}
              className="innovation-ts-topic-wrapper"
              style={{
                height: onMobile ? `${mobileHeight}px` : `${sectionHeight}px`
              }}
              aria-hidden={isTopicSelected ? "true" : "false"}
            >
              { i < topics.length - 1 && <div className="innovation-ts-trail" style={{ height: onMobile ? `${mobileHeight}px` : `${sectionHeight}px` }} /> }
              <TopicElement
                topic={topic}
                bubbleLabels={bubbleLabels}
                mainBubbleSize={mainBubbleSize}
                isTopicSelected={isTopicSelected}
                isVisible={isVisible}
                redirectHandler={redirectHandler}
                ref={refTopicAnchors.current[i]}
                onMobile={onMobile}
              />
            </div>
          ))
        }
      </div>
    </div>
  );
});

export default TopicScroller;